import React from 'react';
import { HIERARCHY_LABELS } from '../../utils/hierarchyLabels';

const AdminBreadcrumbNav = ({ selectedItems, onNavigate }) => (
  <div className="breadcrumbs">
    <span className="breadcrumb-item" onClick={() => onNavigate('factories')}>{HIERARCHY_LABELS.factory.plural}</span>
    {selectedItems.factory && (
      <>
        {' > '}
        <span style={{ cursor: 'pointer' }} onClick={() => onNavigate('workshops')}>
          {selectedItems.factory.name}
        </span>
      </>
    )}
    {selectedItems.workshop && (
      <>
        {' > '}
        <span style={{ cursor: 'pointer' }} onClick={() => onNavigate('sections')}>
          {selectedItems.workshop.name}
        </span>
      </>
    )}
    {selectedItems.section && (
      <>
        {' > '}
        <span style={{ cursor: 'pointer' }} onClick={() => onNavigate('rooms')}>
          {selectedItems.section.name}
        </span>
      </>
    )}
    {selectedItems.room && (
      <>
        {' > '}
        <span style={{ cursor: 'pointer' }} onClick={() => onNavigate('cameras')}>
          {selectedItems.room.name}
        </span>
      </>
    )}
  </div>
);

export default AdminBreadcrumbNav;
